import * as MuiDrawer from '@mui/material/Drawer'
import React from 'react'

export type DrawerProps = MuiDrawer.DrawerProps

export function Drawer({ children, ...props }: DrawerProps) {
  return <MuiDrawer.default {...props}>{children}</MuiDrawer.default>
}
